import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

interface CouponAppliedBadgeProps {
  code: string;
  discountAmount: number;
  currency?: string;
  onRemove: () => void;
}

export function CouponAppliedBadge({
  code,
  discountAmount,
  currency = 'INR',
  onRemove,
}: CouponAppliedBadgeProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2,
        backgroundColor: 'rgba(22, 163, 74, 0.08)',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'rgba(22, 163, 74, 0.3)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CheckCircleIcon color="success" fontSize="small" />
        <Box>
          <Typography variant="body2" fontWeight={600} color="success.dark">
            {code}
          </Typography>
          <Typography variant="caption" color="success.dark">
            You saved {formatCurrency(discountAmount)}
          </Typography>
        </Box>
      </Box>
      <Chip
        label="Remove"
        size="small"
        deleteIcon={<CloseIcon />}
        onDelete={onRemove}
        onClick={onRemove}
        sx={{
          backgroundColor: 'transparent',
          border: '1px solid',
          borderColor: 'rgba(22, 163, 74, 0.4)',
          color: 'success.dark',
          '&:hover': {
            backgroundColor: 'rgba(22, 163, 74, 0.15)',
            color: 'success.dark',
          },
        }}
      />
    </Box>
  );
}
